<div class="frame">
    <div #container class="container">
        <div  style="width: 100%; text-align: center; padding-top: 80px">
            <button mat-raised-button [disabled]="blockUI" class="buttonStart" type="button" #clickInstall
                    (click)="onClick()">
                install
                <mat-icon>desktop_windows</mat-icon>
            </button>
        </div>
    </div>
</div>

